module.exports = __webpack_public_path__ + "img/red-cross.f7172053.svg";